import templateUrl from "servicestack/auto-query/auto-query-boolean-filter.htm";
import controller from "servicestack/auto-query/auto-query-boolean-filter.controller";

export default {
  bindings: {
    filter: "<",
    onToggle: "&",
    hideCheckboxes: "@",
    hideEmptyGroupings: "@",
    hideGroupingCounts: "@",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
